import { remindersVar, actionAtVar, priceChangeMethodVar } from '../variables'

const toggleReminder = reminder => {
  const reminders = remindersVar()
  remindersVar({ ...reminders, [reminder]: !reminders[reminder] })
}

const togglePriceChangeMethod = (priceChangeMethod) => {
  const method = priceChangeMethodVar()

  const updatedMethod = { ...method }
  for (const method of priceChangeMethod) {
    updatedMethod[method] = !updatedMethod[method]
  }

  priceChangeMethodVar(updatedMethod)
}

const setActionAt = (selectedPeriod, selectedDate, selectedTime) => {
  actionAtVar({
    selectedPeriod,
    selectedDate,
    selectedTime,
  })
}

export { toggleReminder, togglePriceChangeMethod, setActionAt }
